import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'updateDmNotificationStatus/';
const url = apiUrl + endPoint;

export interface UpdateDmNotificationStatusRequest {
  OrgUUID: string;
  DmEnabled: boolean;
}

export interface UpdateDmNotificationStatusResponse {
  Success: boolean;
  DmEnabled: boolean;
  Error: string | null;
}

const updateDmNotificationStatus = async (
  req: UpdateDmNotificationStatusRequest,
  headerObj: headerObject
): Promise<UpdateDmNotificationStatusResponse | null> => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
        DmEnabled: req.DmEnabled,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data;
  } catch (err) {
    console.error('Error updating DM notification status:', err);
    return null;
  }
};

export default updateDmNotificationStatus;
